module.exports = __webpack_public_path__ + "media/28-01a-fr.0a954690.mp4";